
(function() {
  var result = { translations: { "pt-pt": { "i18n": { "duration": { "seconds": "{{ seconds }} seg.", "minutes": "{{ minutes }} min.", "hours": "{{ hours }} h", "hoursAndMinutes": "{{ hours }} h {{ minutes }} min.", "days": "{{ days }} dias", "shortForm": { "seconds": "{{ seconds }}s", "minutes": "{{ minutes }}m", "hours": "{{ hours }}h", "days": "{{ days }}d", "hoursAndMinutes": "{{ hours }}h {{ minutes }}m" } }, "dateTime": { "quarterAndYear": "T{{quarterNumber}} de {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{amountNumberValue}} {{currencyCode}}", "phoneNumberWithExtension": "{{phoneNumber}}, ext. {{extension}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "pt-pt": "static-7.1082"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.1082",
    "ar-eg": "static-7.1082",
    "bg": "static-7.1082",
    "bn": "static-7.1082",
    "ca-es": "static-7.1082",
    "cs": "static-7.1082",
    "da": "static-7.1082",
    "de": "static-7.1082",
    "el": "static-7.1082",
    "en-gb": "static-7.1082",
    "en": "static-7.1082",
    "es-mx": "static-7.1082",
    "es": "static-7.1082",
    "et": "static-7.1082",
    "fi": "static-7.1082",
    "fr-ca": "static-7.1082",
    "fr": "static-7.1082",
    "he-il": "static-7.1082",
    "hi": "static-7.1082",
    "hr": "static-7.1082",
    "hu": "static-7.1082",
    "id": "static-7.1082",
    "it": "static-7.1082",
    "ja": "static-7.1082",
    "ko": "static-7.1082",
    "lt": "static-7.1082",
    "ms": "static-7.1082",
    "nl": "static-7.1082",
    "no": "static-7.1082",
    "pl": "static-7.1082",
    "pt-br": "static-7.1082",
    "pt-pt": "static-7.1082",
    "ro": "static-7.1082",
    "ru": "static-7.1082",
    "sk": "static-7.1082",
    "sl": "static-7.1082",
    "sv": "static-7.1082",
    "th": "static-7.1082",
    "tl": "static-7.1082",
    "tr": "static-7.1082",
    "uk": "static-7.1082",
    "vi": "static-7.1082",
    "x-pseudo": "static-7.1082",
    "zh-cn": "static-7.1082",
    "zh-hk": "static-7.1082",
    "zh-tw": "static-7.1082"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:pt-pt', {version: 'static-7.1082'}); }
})();


